<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="grid">
    <!-- ==================== LEFT COLUMN ==================== -->
    <div class="col-12 md:col-12 lg:col-12 xl:col-6 pb-0">
      <div class="flex flex-column gap-2 mb-4">
        <label for="practice">{{ 'layout.configurations.category.practice' | translate }}</label>
        <p-dropdown formControlName="practice" [options]="practices" optionLabel="name" dataKey="id"
          [placeholder]="'layout.configurations.category.selectPractice' | translate"
          (onChange)="onPracticeChange($event)" [showClear]="true" styleClass="w-full" />
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="careerPath"> {{ 'layout.configurations.category.addCategory.careerPath' | translate
          }}</label>
        <p-dropdown formControlName="careerPath" [options]="filteredCareerPaths"
          [placeholder]="'layout.configurations.category.addCategory.careerPath' | translate" optionLabel="name"
          dataKey="id" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('careerPath') }" />
        <div *ngIf="isInvalid('careerPath')" class="text-red-600">{{ errorMessages['careerPath'] | translate }}</div>
      </div>
      <div class="flex flex-column gap-2 mb-4" data-testid="level-field">
        <label emRequiredMark for="level">{{ 'layout.configurations.category.addCategory.level' | translate }}</label>
        <p-dropdown id="level" formControlName="level" [options]="levels"
          [placeholder]="'layout.configurations.category.addCategory.level' | translate"
          [emptyMessage]="'layout.configurations.category.addCategory.level' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('level') }" />
        <div *ngIf="isInvalid('level')" class="text-red-600">{{ errorMessages['level'] | translate }}</div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="categoryShortLabel">{{
          'layout.configurations.category.addCategory.shortLabel' | translate
          }}</label>
        <input id="categoryShortLabel" formControlName="categoryShortLabel" type="text" pInputText
          [placeholder]="'layout.configurations.category.addCategory.shortLabel' | translate" class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('categoryShortLabel') }" />
        <div *ngIf="isInvalid('categoryShortLabel')" class="text-red-600">
          {{ errorMessages['categoryShortLabel'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="categoryLongLabel">{{
          'layout.configurations.category.addCategory.longLabel' | translate
          }}</label>
        <input id="categoryLongLabel" formControlName="categoryLongLabel" type="text" pInputText
          [placeholder]="'layout.configurations.category.addCategory.longLabel' | translate" class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('categoryLongLabel') }" />
        <div *ngIf="isInvalid('categoryLongLabel')" class="text-red-600">
          {{ errorMessages['categoryLongLabel'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="division">{{ 'layout.configurations.category.addCategory.division' | translate
          }}</label>
        <p-dropdown id="division" formControlName="division" [options]="divisions"
          [placeholder]="'layout.configurations.category.addCategory.division' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('division') }" />
        <div *ngIf="isInvalid('division')" class="text-red-600">{{ errorMessages['division'] | translate }}</div>
      </div>
      <!-- NEW: Group combobox -->
      <div class="flex flex-column gap-2 mb-4">
        <label for="group">{{ 'layout.configurations.category.group' | translate }}</label>
        <p-dropdown id="group" formControlName="group" [options]="groups"
          [placeholder]="'layout.configurations.category.group' | translate" styleClass="w-full" [showClear]="true" />
      </div>
      <!-- MOVED from right column: isSupervisor -->
      <div class="flex align-items-center gap-2 mb-4">
        <input type="checkbox" id="supervisor" formControlName="supervisor"
          style="width: 18px; height: 18px; cursor: pointer;" />
        <label for="supervisor" style="cursor: pointer;">
          {{ 'layout.configurations.category.addCategory.isSupervisor' | translate }}
        </label>
      </div>
    </div>

    <!-- ==================== RIGHT COLUMN ==================== -->
    <div class="col-12 md:col-12 lg:col-12 xl:col-6">
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="geoCountry">{{ 'layout.configurations.category.addCategory.geoCountry' | translate
          }}</label>
        <p-dropdown id="geoCountry" formControlName="geoCountry" [options]="countries"
          [placeholder]="'layout.configurations.category.addCategory.geoCountry' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('geoCountry') }" />
        <div *ngIf="isInvalid('geoCountry')" class="text-red-600">{{ errorMessages['geoCountry'] | translate }}</div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="professionalCategorization">{{
          'layout.configurations.category.addCategory.professionalCategorization' | translate
          }}</label>
        <p-dropdown id="professionalCategorization" formControlName="professionalCategorization"
          [options]="professionalCategories"
          [placeholder]="'layout.configurations.category.addCategory.professionalCategorization' | translate"
          styleClass="w-full" [ngClass]="{ 'p-invalid': isInvalid('professionalCategorization') }" />
        <div *ngIf="isInvalid('professionalCategorization')" class="text-red-600">
          {{ errorMessages['professionalCategorization'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="businessUnit">{{
          'layout.configurations.category.addCategory.businessUnit' | translate
          }}</label>
        <p-dropdown id="businessUnit" formControlName="businessUnit" [options]="businessUnits"
          [placeholder]="'layout.configurations.category.addCategory.businessUnit' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('businessUnit') }" />
        <div *ngIf="isInvalid('businessUnit')" class="text-red-600">
          {{ errorMessages['businessUnit'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="talentFamily">{{
          'layout.configurations.category.addCategory.talentFamily' | translate
          }}</label>
        <p-dropdown id="talentFamily" formControlName="talentFamily" [options]="talentFamilies"
          [placeholder]="'layout.configurations.category.addCategory.talentFamily' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('talentFamily') }" />
        <div *ngIf="isInvalid('talentFamily')" class="text-red-600">
          {{ errorMessages['talentFamily'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="elTalentSegment">{{
          'layout.configurations.category.addCategory.elTalentSegment' | translate
          }}</label>
        <p-dropdown id="elTalentSegment" formControlName="elTalentSegment" [options]="talentSegments"
          [placeholder]="'layout.configurations.category.addCategory.elTalentSegment' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('elTalentSegment') }" />
        <div *ngIf="isInvalid('elTalentSegment')" class="text-red-600">
          {{ errorMessages['elTalentSegment'] | translate }}
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="jobRole">{{ 'layout.configurations.category.addCategory.jobRole' | translate
          }}</label>
        <p-dropdown id="jobRole" formControlName="jobRole" [options]="jobRoles"
          [placeholder]="'layout.configurations.category.addCategory.jobRole' | translate" styleClass="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('jobRole') }" />
        <div *ngIf="isInvalid('jobRole')" class="text-red-600">{{ errorMessages['jobRole'] | translate }}</div>
      </div>
      <!-- MOVED from left column: Group 1 -->
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="group1">{{ 'layout.configurations.category.addCategory.group1' | translate }}</label>
        <input id="group1" formControlName="group1" type="text" pInputText
          [placeholder]="'layout.configurations.category.addCategory.group1' | translate" class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('group1') }" />
        <div *ngIf="isInvalid('group1')" class="text-red-600">{{ errorMessages['group1'] | translate }}</div>
      </div>
      <!-- MOVED from left column: Group 2 -->
      <div class="flex flex-column gap-2 mb-4">
        <label emRequiredMark for="group2">{{ 'layout.configurations.category.addCategory.group2' | translate }}</label>
        <input id="group2" formControlName="group2" type="text" pInputText
          [placeholder]="'layout.configurations.category.addCategory.group2' | translate" class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('group2') }" />
        <div *ngIf="isInvalid('group2')" class="text-red-600">{{ errorMessages['group2'] | translate }}</div>
      </div>
    </div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check"
      [label]="'layout.configurations.category.addCategory.save' | translate"></p-button>
  </div>
</form>